/* eslint-disable unicorn/empty-brace-spaces */
/* eslint-disable no-empty */
/* eslint-disable unicorn/prefer-optional-catch-binding */
import { Fragment, useRef, useEffect } from 'react';
import {
  Dialog,
  DialogBackdrop,
  Transition,
  TransitionChild
} from '@headlessui/react';
import Carousel from 'react-multi-carousel';
// import closeimg from '../../public/img/close-icn.svg';
import { XIcon } from '@heroicons/react/solid';

export default function ProductLightbox({
  close,
  image,
  images
}: {
  close: () => void;
  image: string;
  images: string[];
}) {
  const carouselRef = useRef<any>();

  useEffect(() => {
    if (carouselRef.current) {
      const currentIndex = images.indexOf(image) || 0;
      setTimeout(() => {
        carouselRef.current.goToSlide(currentIndex);
      }, 500);
    }
  }, [carouselRef.current]);

  return (
    <Transition show={!!image}>
      <Dialog
        as="div"
        className="fixed z-30 inset-0 overflow-y-auto"
        onClose={close}
      >
        <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
          <TransitionChild
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <DialogBackdrop className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </TransitionChild>

          {/* This element is to trick the browser into centering the modal contents. */}
          <span
            className="hidden sm:inline-block sm:align-middle sm:h-screen"
            aria-hidden="true"
          >
            &#8203;
          </span>
          <TransitionChild
            enter="ease-out duration-300"
            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enterTo="opacity-100 translate-y-0 sm:scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          >
            <div className="inline-block align-bottom text-left overflow-hidden transform transition-all sm:my-8 sm:align-middle sm:w-9/12">
              <div className="text-center">
                {/* <button onClick={close}>close</button> */}
                <button
                  className="bg-white text-primary rounded-full w-14 h-14 flex justify-center items-center m-auto mb-2 focus:outline-none"
                  onClick={close}
                >
                  <XIcon className="w-5 h-5" />
                </button>
                <div className="">
                  <Carousel
                    ref={carouselRef}
                    ssr
                    responsive={{
                      all: {
                        breakpoint: { max: 3000, min: 0 },
                        items: 1
                      }
                    }}
                    slidesToSlide={1}
                    swipeable={true}
                    draggable={true}
                    containerClass="carousel-container lightbox-carousel"
                    showDots={false}
                    renderButtonGroupOutside={true}
                  >
                    {images.map(image => {
                      return (
                        <div
                          key={image}
                          className="rounded-md bg-white height-80vh width-80vh bg-contain bg-no-repeat bg-center m-auto"
                          style={{ backgroundImage: 'url(' + image + ')' }}
                        />
                      );
                    })}
                  </Carousel>
                </div>
              </div>
            </div>
          </TransitionChild>
        </div>
      </Dialog>
    </Transition>
  );
}
